var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('BaseEmailPart',_vm._b({staticClass:"part-inner-container"},'BaseEmailPart',_vm.$attrs,false),[_c('p',[_c('span',[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }